import React from "react";
import styled from "styled-components";

const Block = styled.div`
  width: 262px;
  height: 213px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 36px 0px;

  @media (max-width: 1024px) {
    width: 182px;
    height: 151px;
  }

  @media (max-width: 768px) {
    width: 140px;
    height: 120px;
    margin: 0 10px;
  }
`;

const Icon = styled.img`
  max-width: 220px;
  height: auto;

  @media (max-width: 1024px) {
    max-width: 153px;
  }

  @media (max-width: 768px) {
    max-width: 140px;
  }
`;

interface Props {
  icon?: string;
  name?: string;
  backgroundColor?: string;
}

const Insurance: React.FC<Props> = ({ icon, name, backgroundColor }) => {
  return (
    <Block style={{ backgroundColor: backgroundColor }}>
      <Icon src={icon} alt={name} />
    </Block>
  );
};

export default Insurance;
